<template>
    <div id="data-list-list-view" class="data-list-container">
        <vs-table
            ref="table"
            no-data-text="Nenhum documento encontrado"
            multiple
            v-model="selected"
            pagination
            :max-items="itemsPerPage"
            :data="documentsFavoriteLists"
        >
            <div slot="header" class="flex w-full items-end">
                <div>
                    <vs-input
                        placeholder="Buscar"
                        class="w-full input-rounded-full no-icon-border mr-4"
                        icon="icon-search"
                        icon-pack="feather"
                        v-model="term"
                        @keyup.enter="searchHandler()"
                    />
                </div>
                <div>
                    <vs-button
                        class="mr-4"
                        color="danger"
                        type="filled"
                        @click="confirmRemoveDocumentList"
                    >Remover</vs-button>
                </div>
            </div>

            <template slot="thead">
                <vs-th sort-key="id">ID</vs-th>
                <vs-th sort-key="title_default">Título</vs-th>
                <vs-th sort-key="access_level">Nível de acesso</vs-th>
                <vs-th sort-key="access_level">Data de Inclusão</vs-th>
                <vs-th>&nbsp;</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            <p class="term font-medium">{{ tr.id }}</p>
                        </vs-td>
                        <vs-td>
                            <p class="term font-medium">{{ tr.title_default }}</p>
                        </vs-td>
                        <vs-td>
                            <p class="term font-medium">{{ tr.access_level | access_level }}</p>
                        </vs-td>
                        <vs-td>
                            <p class="term font-medium">{{ tr.created_at | relativeDate }}</p>
                        </vs-td>
                        <vs-td>
                            <router-link :to="`/documents/${tr.id}`">
                                <vx-tooltip text="Abrir documento" class="w-6 h-6" color="grey">
                                    <feather-icon icon="EyeIcon" class="w-6 h-6"></feather-icon>
                                </vx-tooltip>
                            </router-link>
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>

<script>
import { sync, call } from "vuex-pathify";

export default {
    data() {
        return {
            itemsPerPage: 40,
            isMounted: false
        };
    },
    computed: {
        documentsFavoriteLists: sync(
            "documentsFavoriteLists/documentsFavoriteLists"
        ),
        term: sync("documentsFavoriteLists/term"),
        selected: sync("documentsFavoriteLists/selectedItems")
    },
    async created() {
        this.reset();
        this.searchHandler();
    },
    async mounted() {
        this.isMounted = true;
        // this.fetchUsers();
    },
    methods: {
        ...call([
            "documentsFavoriteLists/fetch",
            "documentsFavoriteLists/update",
            "documentsFavoriteLists/reset",
            "documentsFavoriteLists/removeDocumentFavoriteList"
        ]),
        async searchHandler() {
            this.$vs.loading();
            try {
                await this.fetch(this.$route.params.id);
                this.$vs.loading.close();
            } catch (error) {
                console.log(error);
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro",
                    text:
                        "Não foi possível carregar esta página. Tente novamente mais tarde, por favor.",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
        },
        confirmRemoveDocumentList() {
            if (this.selected.length == 0) {
                this.$vs.notify({
                    title: "Erro",
                    text: "Selecione os documentos para poder remove-los.",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            } else {
                this.$vs.dialog({
                    type: "confirm",
                    color: "danger",
                    title: "Remover documento da lista de favoritos",
                    text:
                        "Tem certeza que deseja remover este documento da lista de favoritos?",
                    acceptText: "Remover",
                    cancelText: "Cancelar",
                    accept: () => this.deleteDocumentFavoriteListHandler()
                });
            }
        },
        async deleteDocumentFavoriteListHandler(id) {
            this.$vs.loading();
            try {
                await this.removeDocumentFavoriteList({
                    document_id: this.selected,
                    favorite_list_id: this.$route.params.id
                });
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Removido",
                    text:
                        "Documento removido da lista de favoritos com sucesso!.",
                    color: "success",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            } catch (error) {
                console.log(error);
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro",
                    text:
                        "Não foi possível remover o documento da lista de favoritos. Tente novamente mais tarde!",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
        }
    }
};
</script>

<style lang="scss">
#data-list-list-view {
    .vs-con-table {
        .vs-table--header {
            display: flex;
            flex-wrap: wrap-reverse;
            margin-left: 1.5rem;
            margin-right: 1.5rem;
            > span {
                display: flex;
                flex-grow: 1;
            }

            .vs-table--search {
                padding-top: 0;

                .vs-table--search-input {
                    padding: 0.9rem 2.5rem;
                    font-size: 1rem;

                    & + i {
                        left: 1rem;
                    }

                    &:focus + i {
                        left: 1rem;
                    }
                }
            }
        }

        .vs-table {
            border-collapse: separate;
            border-spacing: 0 1.3rem;
            padding: 0 1rem;

            tr {
                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                td {
                    padding: 20px;
                    &:first-child {
                        border-top-left-radius: 0.5rem;
                        border-bottom-left-radius: 0.5rem;
                    }
                    &:last-child {
                        border-top-right-radius: 0.5rem;
                        border-bottom-right-radius: 0.5rem;
                    }
                }
                td.td-check {
                    padding: 20px !important;
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 0;
                padding-bottom: 0;

                .vs-table-text {
                    text-transform: uppercase;
                    font-weight: 600;
                }
            }
            th.td-check {
                padding: 0 15px !important;
            }
            tr {
                background: none;
                box-shadow: none;
            }
        }

        .vs-table--pagination {
            justify-content: center;
        }

        .vs-button {
            margin-left: 20px;
        }
    }
}
</style>